export default "/images/d00967e2944aec870a8cba4dc8c62b72.avif";